const initState = {
  mainAddProgress: 0,
  mainAddProgressType: null,
  mainAdding: null,
  mainAdded: false,
  mainAddError: null,

  secondAdding: null,
  secondAdded: false,
  secondAddError: null,

  paymentDetailsAdding: null,
  paymentDetailsAddError: null,
  paymentDetailsAdd: false,

  signupAdding: null,
  signupAddError: null,
  signupAdd: false,

  verficationEmailSending: null,
  verficationEmailSendError: null,
  verficationEmailSent: false,

  paymentInitiate: false,
  paymentDone: false,
  paymentError: null,

  refundInitiate: false,
  refundDone: false,
  refundError: null,
};

const newSignUpReducer = (state = initState, action) => {
  switch (action.type) {
    case "MAIN_AGREEMENT_UPLOAD":
      return {
        ...state,
        mainAddProgress: action.value,
        mainAddProgressType: action.media,
        mainAdding: true,
      };
    case "MAIN_AGREEMENT_SUCESS":
      return {
        ...state,
        mainAddProgress: 0,
        mainAddProgressType: null,
        mainAdding: false,
        mainAdded: true,
        mainAddError: null,
      };
    case "MAIN_AGREEMENT_CLEAR_STATUS":
      return {
        ...state,
        paymentDetailsAddError: null,
        paymentDetailsAdd: null,
        paymentDetailsAdding: false,
      };
    case "MAIN_AGREEMENT_ERROR":
      return {
        ...state,
        mainAddError: "Add failed",
        mainAdded: false,
        mainAddProgress: 0,
        mainAddProgressType: null,
        mainAdding: false,
      };

    case "SECOND_AGREEMENT_UPLOAD":
      return {
        ...state,
        secondAdding: true,
        secondAdded: false,
        secondAddError: null,
      };
    case "SECOND_AGREEMENT_SUCESS":
      return {
        ...state,
        secondAdding: false,
        secondAdded: true,
        secondAddError: null,
      };
    case "SECOND_AGREEMENT_CLEARSTATUS":
      return {
        ...state,
        secondAdding: false,
        secondAdded: false,
        secondAddError: null,
      };
    case "SECOND_AGREEMENT_ERROR":
      return {
        ...state,
        secondAdding: false,
        secondAdded: false,
        secondAddError: "Add failed",
      };

    case "PAYMENT_DETAILS_ADD":
      return {
        ...state,
        paymentDetailsAddError: null,
        paymentDetailsAdd: false,
        paymentDetailsAdding: true,
      };
    case "PAYMENT_DETAILS_SUCCESS":
      return {
        ...state,
        paymentDetailsAddError: null,
        paymentDetailsAdd: true,
        paymentDetailsAdding: false,
      };
    case "PAYMENT_DETAILS_CLEAR_STATUS":
      return {
        ...state,
        paymentDetailsAddError: null,
        paymentDetailsAdd: null,
        paymentDetailsAdding: false,
      };
    case "PAYMENT_DETAILS_ERROR":
      return {
        ...state,
        paymentDetailsAdding: false,
        paymentDetailsAddError: action.err,
        paymentDetailsAdd: false,
      };

    case "SIGNUP_ADDING":
      return {
        ...state,
        signupAddError: null,
        signupAdd: false,
        signupAdding: true,
      };
    case "SIGNUP_ADD_SUCCESS":
      return {
        ...state,
        signupAddError: null,
        signupAdd: true,
        signupAdding: false,
      };
    case "SIGNUP_DETAILS_CLEAR_STATUS":
      return {
        ...state,
        signupAddError: null,
        signupAdd: null,
        signupAdding: false,
      };
    case "SIGNUP_ADD_ERROR":
      return {
        ...state,
        signupAdd: false,
        signupAddError: action.error,
        signupAdding: false,
      };

    case "LINK_SENDING":
      return {
        ...state,
        verficationEmailSending: true,
        verficationEmailSendError: null,
        verficationEmailSent: false,
      };
    case "LINK_SENT":
      return {
        ...state,
        verficationEmailSending: false,
        verficationEmailSendError: null,
        verficationEmailSent: true,
      };
    case "LINK_SEND_CLEAR_STATUS":
      return {
        ...state,
        verficationEmailSending: null,
        verficationEmailSendError: null,
        verficationEmailSent: false,
      };
    case "LINK_SEND_ERROR":
      return {
        ...state,
        verficationEmailSending: null,
        verficationEmailSendError: action.err,
        verficationEmailSent: false,
      };

    case "PAYMENT_HAPPENING":
      return {
        ...state,
        paymentInitiate: true,
        paymentError: null,
        paymentDone: false,
      };
    case "PAYMENT_DONE":
      return {
        ...state,
        paymentInitiate: false,
        paymentError: null,
        paymentDone: true,
      };
    case "PAYMENT_CLEAR_STATUS":
      return {
        ...state,
        paymentInitiate: false,
        paymentError: null,
        paymentDone: false,
      };
    case "PAYMENT_ERROR":
      return {
        ...state,
        paymentInitiate: false,
        paymentError: action.err,
        paymentDone: false,
      };
    case "REFUND_HAPPENING":
      return {
        ...state,
        refundInitiate: true,
        refundError: null,
        refundDone: false,
      };
    case "REFUND_DONE":
      return {
        ...state,
        refundInitiate: false,
        refundError: null,
        refundDone: true,
      };
    case "REFUND_CLEAR_STATUS":
      return {
        ...state,
        refundInitiate: false,
        refundError: null,
        refundDone: false,
      };
    case "REFUND_ERROR":
      return {
        ...state,
        refundInitiate: false,
        refundError: action.err,
        refundDone: false,
      };

    default:
      return state;
  }
};

export default newSignUpReducer;
